import { Component, Input, OnInit } from '@angular/core';
import { ImportTmsLoadResult } from '../../../shared/tms-import/import-tms-load-result';
import { NavigationLinkService } from '../../../../shared/services/navigation-link.service';

@Component({
  selector: 'app-tms-import-load-result',
  templateUrl: './tms-import-load-result.component.html',
  styleUrls: ['./tms-import-load-result.component.scss']
})
export class TmsImportLoadResultComponent implements OnInit {

  @Input()
  result: ImportTmsLoadResult;

  constructor(public link: NavigationLinkService) {}

  ngOnInit() {
  }

}
